import React from 'react';

const ValueProposition = ({ data }) => {
  return (
    <section className="p-80px-tb value-proposition" style={{backgroundColor: 'white'}}>
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center m-50px-b">
            <h2 className="section-title font-weight-bold m-20px-b">{data.title}</h2>
            <h3 className="h4 text-primary">{data.subtitle}</h3>
          </div>
        </div>
        {data.values.map((value, index) => (
          <div key={index} className="row align-items-center m-50px-b">
            <div className={`col-lg-6 ${index % 2 === 1 ? 'order-lg-2' : ''}`}>
              <div className="value-content p-40px">
                <div className="value-number display-1 font-weight-bold text-primary m-20px-b">
                  {value.number}
                </div>
                <h3 className="font-weight-bold m-25px-b">{value.title}</h3>
                <p className="lead text-primary font-weight-bold m-20px-b">
                  {value.highlight}
                </p>
                <p className="text-muted">
                  {value.content}
                </p>
              </div>
            </div>
            <div className={`col-lg-6 ${index % 2 === 1 ? 'order-lg-1' : ''}`}>
              {/* 価値提案のビジュアル */}
              <div className="value-visual-placeholder">
                <img
                  src={index === 0
                    ? process.env.PUBLIC_URL + "/assets/img/future.webp"
                    : process.env.PUBLIC_URL + "/assets/img/experience.png"}
                  alt={index === 0 ? '高速PDCAサイクル' : 'チーム成長'}
                  className="img-fluid rounded"
                  style={{width: '100%', height: 'auto'}}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ValueProposition;